module.exports = __webpack_public_path__ + "media/Images/GettyImages-007-cc4a54a54c310aad549b8489eb7ec2e3.svg";